import React, { PureComponent, Fragment } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import { Datepicker, Loader } from 'modules/shared'
import { DateTime } from 'luxon'
import Select from 'react-select'
import { emissToDate, numFormat, formatCNPJ, showNotification } from 'helpers'
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { fetchCtes, downloadXML, getDACTE } from '../actions/cteActions'

const { SearchBar } = Search
const ExportCSV = (props) => {
    const handleClick = () => props.onExport()
    return <button style={{ borderRadius: 0 }} className="btn btn-info btn-sm" disabled={props.disabled} onClick={handleClick}>Exportar CSV</button>
}

class CTeConsulta extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            dateIni: DateTime.local().minus({ days: 1}).startOf('month').toJSDate(),
            dateEnd: DateTime.local().minus({ days: 1}).endOf('month').toJSDate(),
            filteredCompanies: [],
            filteredEmit: '',
            filteredBusca: ''
        }
    }

    componentDidMount() {
        this.props.fetchCtes(this.state)
    }

    filterReport() {
        if (DateTime.fromJSDate(this.state.dateIni) <= DateTime.fromJSDate(this.state.dateEnd))
            this.props.fetchCtes(this.state)
        else 
            showNotification('Data inicial deve ser anterior à final.', 'alert-warning', 3000)
    }

    updateDates(dates) {
        if (dates.length >= 1 && (DateTime.fromJSDate(this.state.dateIni).toFormat('yyyyMMdd') !== DateTime.fromJSDate(dates[0]).toFormat('yyyyMMdd') || DateTime.fromJSDate(this.state.dateEnd).toFormat('yyyyMMdd') !== DateTime.fromJSDate(dates[1]).toFormat('yyyyMMdd'))) {
            if (dates.length === 1)
                this.setState({ dateIni: dates[0], dateEnd: dates[0] })
            else
                this.setState({ dateIni: dates[0], dateEnd: dates[1] })            
        }
    }

    filterCompanies(value) {
        let _ids = value.map(v => v.value)
        this.setState({
            filteredCompanies: this.props.cteState.empresas.filter(p => _ids.includes(p._id)).map(p => p._id)
        })
    }

    filterEmitentes(filter) {
        this.setState({
            filteredEmit: filter.value
        })
    }

    filterBusca(filter) {
        this.setState({
            filteredBusca: filter.value
        })
    }
    
    render() {
        let { loading, ctes, empresas } = this.props.cteState

        if (loading)
            return <Loader />

        empresas = empresas && empresas.length ? empresas : []
        const options = empresas.map(p => Object.assign({}, { value: p._id, label: p.nomeEmpresa }) )

        let transportadoras = empresas && empresas.length ? empresas.filter(emp => emp.tipo === 'TRANSPORTADORA') : []
        transportadoras.push({ cnpjPrincipal: 'rdp', nomeEmpresa: 'TODAS AS TRASNPORTADORAS RDP' })
        transportadoras.push({ cnpjPrincipal: 'outros', nomeEmpresa: 'OUTROS' })

        const optionsTransp = transportadoras.map(p => Object.assign({}, { value: p.cnpjPrincipal, label: p.nomeEmpresa }) )
        const optionsTypes = [
            { value: 'tomador', label: 'Buscar por Tomador' },
            { value: 'destinatario', label: 'Buscar por Destinatário' }
        ]

        const acoes = (chave, row) => (
            <div>
                <button style={{ fontSize: '.6rem' }} className="btn btn-sm btn-success py-1" onClick={event => this.props.downloadXML(event.currentTarget, chave)}>
                    <i className="fas fa-download"></i> XML
                </button>
                <button style={{ fontSize: '.6rem' }} className="btn btn-sm btn-primary ml-2 py-1" onClick={event => this.props.getDACTE(event.currentTarget, chave)}>
                    <i className="fas fa-eye"></i> DACTE
                </button>
            </div>
        )

        const columns = [
            { dataField: 'index', text: 'index', sort: false, hidden: true, csvExport: false },
            { dataField: '_id', text: 'CHAVE', sort: false, hidden: true, csvExport: true, csvType: 'String' },
            { dataField: 'nomeEmpresa', text: 'EMPRESA', sort: true },
            { dataField: 'destinatario.cnpj', text: 'CNPJ DESTINÁTARIO', hidden: true, csvFormatter: formatCNPJ },
            { dataField: 'emiss_id', text: 'EMIS.', sort: true, formatter: emissToDate, csvFormatter: emissToDate },
            { dataField: 'numero_nota', text: 'NRO.', sort: true, csvType: 'Number' },
            { dataField: 'emitente.nome', text: 'EMITENTE', sort: true, formatter: (cell, row) => cell + ' - ' + formatCNPJ(row.emitente.cnpj) },
            { dataField: 'emitente.cnpj', text: 'CNPJ EMITENTE', hidden: true, csvFormatter: formatCNPJ },
            { dataField: 'valor', text: 'VALOR', sort: true, formatter: cell => numFormat(cell, 2, true) },
            { dataField: '_id', text: 'AÇÕES', sort: false, csvExport: false, formatter: acoes }
        ]

        const expandRow = {
            renderer: row => (
                <div className="row mx-0 px-0 my-3">
                    {!row.finalidade && <div className="col"><p className="ml-3">Para mais detalhes, aguarde o sistema importar o XML da nota.</p></div>}
                    {row.finalidade && 
                        <div className="col mx-0 px-0">
                            <p className="ml-3 mb-0"><strong>CHAVE ACESSO:</strong> {row._id}</p>
                            <p className="ml-3 mb-0"><strong>TOMADOR:</strong> {row.tomador && row.tomador.cnpj ? `${row.tomador.nome} - ${formatCNPJ(row.tomador.cnpj)}` : 'Sem informações' }</p>
                            <p className="ml-3 mb-0"><strong>REMETENTE:</strong> {row.remetente && row.remetente.cnpj ? `${row.remetente.nome} - ${formatCNPJ(row.remetente.cnpj)}` : 'Sem informações' }</p>
                            <p className="ml-3 mb-0"><strong>NFE(S) VINCULADA(S):</strong></p>
                            {!!row.nfes && row.nfes.map((nfe, idx) => <li className="ml-4 mb-0" key={idx}>{` NRO. ${nfe.numero_nota} - ${nfe.chave}`}</li>)}
                        </div>
                    }
                </div>
            ),
            showExpandColumn: true,
            onlyOneExpanding: true,
            expandByColumnOnly: true,
            expandColumnRenderer: ({ expanded }) => !expanded ? <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-plus fa-stack-1x fa-inverse"></i></span> : <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-minus fa-stack-1x fa-inverse"></i></span>,
            expandHeaderColumnRenderer: ({ isAnyExpands }) => !isAnyExpands ? <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-plus fa-stack-1x fa-inverse"></i></span> : <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-minus fa-stack-1x fa-inverse"></i></span>
        }

        const toolkitProps = { keyField: 'index', data: ctes || [], search: { searchFormatted: true }, columns, exportCSV: true }

        return (
            <div className="container-fluid mx-0">

                <div className="row mx-0">
                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Select
                            options={options}
                            defaultValue={empresas.filter(p => this.state.filteredCompanies.includes(p._id)).map(p => Object.assign({}, { value: p._id, label: p.nomeEmpresa }) )}
                            isMulti
                            placeholder="Filtrar empresas..."
                            classNamePrefix="react-select"
                            onChange={value => this.filterCompanies(value)} 
                        />
                    </div>

                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Datepicker
                            defaultDate={[this.state.dateIni, this.state.dateEnd]}
                            onChange={dates => this.updateDates(dates)}
                        />
                    </div>

                    <div className="col mt-2">
                        <button onClick={() => this.filterReport()} className="btn btn-primary btn-sm">
                            <i className="fas fa-sync-alt pr-2"></i>
                            Filtrar                        
                        </button>
                    </div>
                </div>  

                <div className="row mb-4 mx-0">

                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Select
                            options={optionsTransp}
                            defaultValue={transportadoras.filter(p => this.state.filteredEmit === p.cnpjPrincipal).map(p => Object.assign({}, { value: p.cnpjPrincipal, label: p.nomeEmpresa }) )}
                            placeholder="Filtrar emitente..."
                            classNamePrefix="react-select"
                            onChange={value => this.filterEmitentes(value)} 
                        />
                    </div>

                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Select
                            options={optionsTypes}
                            defaultValue={optionsTypes.filter(t => this.state.filteredBusca === t.value)}
                            placeholder="Filtrar busca..."
                            classNamePrefix="react-select"
                            onChange={value => this.filterBusca(value)} 
                        />
                    </div>
                
                </div>              

                <div className="row mx-0">

                    <div className="col mr-4">
                    
                        <ToolkitProvider {...toolkitProps}>
                            {props => 
                                <Fragment>
                                    <div className="row mb-3">
                                        <div className="col col-sm-5 col-md-3">
                                            <SearchBar delay={ 250 } placeholder="Pesquisar na tabela..." className="form-control-sm" {...props.searchProps} />
                                        </div>
                                        <div className="col">
                                            <ExportCSV {...props.csvProps} disabled={props.baseProps.data.length ? false : true} />
                                            <p className="float-right"><strong>Total:</strong> {numFormat(toolkitProps.data.map(d => d.valor).reduce((acc, v) => acc + v, 0), 2, true)}</p>
                                        </div>
                                    </div>
                                    
                                    <BootstrapTable
                                        {...props.baseProps}
                                        expandRow={expandRow}
                                        bootstrap4
                                        defaultSorted={[{ dataField: 'emiss_id', order: 'desc' }]}
                                        hover
                                        classes="table-sm table-font-size"
                                        wrapperClasses="table-responsive"
                                        pagination={paginationFactory({ sizePerPage: 50, sizePerPageList: [50, 100, 150, 200], showTotal: true, paginationTotalRenderer: (from, to, size) => (<span className="pl-3">Exibindo linhas {from} a {to} de {size}</span>) })}
                                        noDataIndication={'Sem dados'}
                                    />
                                </Fragment>
                            }
                        </ToolkitProvider>
                    </div>
                        
                </div>

            </div>
        )
    }   
}

const mapStateToProps = store => ({ cteState: store.cteState })
const mapDispatchToProps = dispatch => bindActionCreators({ fetchCtes, downloadXML, getDACTE }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CTeConsulta)